import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import SportsMenu from 'modules/sports-menu/index.js';
import SportsMenuViewTypes from 'modules/sports-menu/types';

const { UIViewImplementation } = MojitoCore.Presentation;
const { FlexPane, Text, Image, Button, LinkMenu } = MojitoPresentation.Components;

export default class AzOverview extends UIViewImplementation {
    constructor(...args) {
        super(...args);

        this.state = {
            isSearchOpen: false,
        };

        this.onShowAllSportsClick = this.onShowAllSportsClick.bind(this);
        this.onShowSearchClick = this.onShowSearchClick.bind(this);
        this.onSearchCloseClick = this.onSearchCloseClick.bind(this);
        this.onInformationSectionItemClick = this.onInformationSectionItemClick.bind(this);
    }

    get hasInformationItems() {
        return !!this.config.informationSectionItems.length;
    }

    get defaultInformationSectionItems() {
        return this.props.hideSettings
            ? []
            : [
                  {
                      label: '$AZ_MENU.SETTINGS_LABEL',
                      step: 'settings',
                      className: 'ta-settingsButton',
                  },
              ];
    }

    onShowAllSportsClick() {
        this.emitAnalytics('sportsMenuExpandedStateChanged', true);
        this.props.to('all-sports');
    }

    onInformationSectionItemClick({ step }) {
        return step ? this.props.to(step) : this.props.onClose();
    }

    renderSportsListSection() {
        const content = (
            <>
                <SportsMenu
                    viewType={SportsMenuViewTypes.VIEW_TYPES.ONLY_HIGHLIGHTED}
                    cbSportClicked={this.props.onClose}
                    config={this.config.highlightedSports}
                />
                <Button
                    class="ta-allSportsButton"
                    config={this.config.sportsSectionAllSportsButton}
                    onClick={this.onShowAllSportsClick}
                >
                    <Text config={this.config.sportsSectionAllSportsButtonLabel}>
                        {this.resolveString('$AZ_MENU.ALL_SPORTS_BUTTON')}
                    </Text>
                    <Image config={this.config.sportsSectionAllSportsButtonIcon} />
                </Button>
            </>
        );
        return this.renderSection({
            title: this.resolveString('$AZ_MENU.SECTION_TITLE.SPORTS'),
            content,
        });
    }

    renderMoreSection() {
        const items = this.config.moreSectionItems.map(item => ({
            ...item,
            label: this.resolveString(item.label),
        }));
        return this.renderSection({
            title: this.resolveString('$AZ_MENU.SECTION_TITLE.MORE'),
            content: (
                <LinkMenu
                    items={items}
                    onItemClick={this.props.onClose}
                    config={this.config.moreSection}
                />
            ),
        });
    }

    renderInformationSection() {
        const items = [
            ...this.defaultInformationSectionItems,
            ...this.config.informationSectionItems,
        ].map(item => ({
            ...item,
            label: this.resolveString(item.label),
        }));
        const content = (
            <LinkMenu
                items={items}
                onItemClick={this.onInformationSectionItemClick}
                config={this.config.informationSectionContainer}
            />
        );
        return this.renderSection({
            title: this.resolveString('$AZ_MENU.SECTION_TITLE.INFORMATION'),
            content,
        });
    }

    renderSection({ title = '', content = null }) {
        return (
            <FlexPane class="ta-sectionContainer" config={this.config.sectionContainer}>
                <Text config={this.config.sectionName}>{title}</Text>
                {content}
            </FlexPane>
        );
    }

    onShowSearchClick() {
        this.setState({ isSearchOpen: true });
    }

    onSearchCloseClick() {
        this.setState({ isSearchOpen: false });
    }

    renderSearch() {
        if (!this.config.showSearch) {
            return null;
        }
        if (this.state.isSearchOpen) {
            return this.props.renderSearchOverlay(this.onSearchCloseClick, this.state.isSearchOpen);
        }
        return (
            <Button onClick={this.onShowSearchClick}>{this.props.renderSearchComponent()}</Button>
        );
    }

    render() {
        const hasInformationContent = !this.props.hideSettings || this.hasInformationItems;
        return (
            <FlexPane config={this.config.container}>
                {this.renderSearch()}
                {this.renderSportsListSection()}
                {this.config.moreSectionItems.length && this.renderMoreSection()}
                {hasInformationContent && this.renderInformationSection()}
            </FlexPane>
        );
    }
}
